import React from "react";

export default function CookiePage() {
  let standfontsize = 14;


  return (
    <div className="full-site">
      <h1 className="legal-title">
        Cookie Policy
      </h1>

      <p style={{ fontSize: standfontsize }}>
        Fooge (we, us) recognize the importance of your privacy and we understand
        your concerns about the security of your personal information. We are
        committed to protecting any personal information that we hold. This
        Privacy Policy details how we collect, hold, store, use and disclose your
        personal information and your rights in relation to the personal
        information we hold about you.
      </p>

      <h2 className="legal-h2">
        Cookies and Web Beacons
      </h2>

      <p style={{ fontSize: standfontsize }}>
        We may use cookies on our website. Cookies are text files stored in your
        computer's browser to save your preferences. With cookies alone we are
        not able to access your personally identifiable information (e.g. email
        address, name). If and when you choose to provide our online Services
        with personal information, this information may be linked to the data
        stored in the cookie.
        <br />
        You are able to block cookies by activating the setting on your browser.
        However, if you block all cookies (including essential cookies) you may
        not be able to access all or parts of our online Services.
        <br />
        We may use web beacons on our website. Web beacons are small pieces of
        code placed on a web page to monitor the visitor's behavior and collect
        data about the visitor's viewing of a web page. For example, web beacons
        can be used to count the number of visits to a web page, or gauge which
        parts of a website are most popular.
        <br />
        We may use Google Analytics to collect and process data. To find out how
        Google uses data when you use third party websites or applications,
        please see www.google.com/policies/privacy/partners/.
      </p>

      <h2 className="legal-h2">
        Advertising related third parties
      </h2>

      <p style={{ fontSize: standfontsize }}>
        We use Google Analytics to help us understand how our customers use the
        Site. You may read more about how Google uses your personal data here:{" "}
        <a
          href="https://www.google.com/intl/en/policies/privacy/"
          target="_blank"
          rel="noreferrer"
        >
          https://www.google.com/intl/en/policies/privacy/
        </a>
        .
        <br />
        You are also able to opt-out of Google Analytics here:{" "}
        <a
          href="https://tools.google.com/dlpage/gaoptout"
          target="_blank"
          rel="noreferrer"
        >
          https://tools.google.com/dlpage/gaoptout
        </a>
        .
      </p>
    </div>
  );
}
